<template>
    <v-app>
        <Drawer current_item="menu_appointment_guide" :mini="true"></Drawer>
        <v-main class="ma-6">
                <v-row>
                    <v-col cols="12" md="4">
                        <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
                    </v-col>
                </v-row>
                <a :href="qrcode" v-if="qrcode.length>0">
                    <QrcodeVue :value="qrcode" size="300" level="H"></QrcodeVue>
                </a>
        </v-main>
    </v-app>
</template>

<script>

import Drawer from '@/components/Drawer.vue'
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import QrcodeVue from 'qrcode.vue'
import config from '@/../config.js'

import axios from 'axios';


export default {
    components: {
        Drawer
        ,FragmentSelectStation
        ,QrcodeVue
    },
    mounted : function () {
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.public.station.get_activateqrcode,{station_code:this.$route.params.station_code})
        .then(response => {
            this.$store.commit('finishLoading',que)
            this.qrcode = response.data.url
        })
    },
    data () {
        return {
            qrcode : ""
        }
    },
    methods: {
        onStationChange(station){
            document.location = station.station_code
        }
    }
}
</script>